import { palette } from '@app/palette';
import { Box, Grid, Typography } from '@mui/material';
import React, { FC } from 'react';
interface SurveyTitleProps {
  title: string | undefined;
}
export const SurveyTitle: FC<SurveyTitleProps> = ({ title }) => {
  return (
    <Box
      component={'div'}
      sx={{
        display: 'flex',
        padding: 1,
        backgroundColor: palette.primary.light,
      }}
    >
      <Grid
        container
        sx={{
          display: 'flex',
          justifyContent: 'center',
          flexDirection: 'row',
        }}
      >
        <Grid>
          <Typography sx={{ color: palette.secondary.contrastText }} variant={'h4'}>
            {title}
          </Typography>
        </Grid>
      </Grid>
    </Box>
  );
};
